'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import JumpLink from '@/components/JumpLink';
import style from '../style.module.scss';

// ---------------引入埋点------------------
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

interface CampaignProps {
  PageConfig: any;
  floorIndex: number;
}
export default function Campaign(props: CampaignProps) {
  const { PageConfig, floorIndex } = props;
  const Img = (props: any) => {
    const { data, index, jumpParams } = props;
    return (
      <div
        key={index}
        onClick={(e) =>
          spmTrackingUtils.spmClick({
            spm: `a0145.b002244.c00002832.${index + 1}`,
            page_id: 'Mini_Hp',
            event_id: 'Home_Mini_Hp_Activity',
            target: e.target as HTMLElement,
            json_param: JSON.stringify(jumpParams),
          })
        }
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exp={JSON.stringify({
          spm: `a0145.b002244.c00002832.${index + 1}`,
          page_id: 'Mini_Hp',
          event_id: 'Home_Mini_Hp_Activity_Expo',
          json_param: jumpParams,
        })}
      >
        <CDNImage
          // @ts-ignore
          src={data?.imageUrl}
          width={data.imageWidth}
          height={data.imageHeight}
          alt='campaign Image'
          priority={floorIndex < 6 && index < 3}
          style={{ borderRadius: '4px' }}
        />
      </div>
    );
  };
  return (
    <div className={style.adsModule}>
      {PageConfig.data.length === 1 && (
        <>
          <JumpLink jumpParams={PageConfig.data[0].jump}>
            <Img
              data={PageConfig.data[0].img_large}
              index={0}
              jumpParams={PageConfig.data[0].jump}
            />
          </JumpLink>
        </>
      )}
      {PageConfig.length === 2 &&
        PageConfig.data.map((ad: any, index: any) => (
          <JumpLink jumpParams={ad.jump} key={`campaign${index}`}>
            <Img data={ad.img_middle} index={index} jumpParams={ad.jump} />
          </JumpLink>
        ))}
      {PageConfig.length > 2 && (
        <div className={style.adsContainer}>
          {PageConfig.data.map((ad: any, index: any) => (
            <JumpLink jumpParams={ad.jump} key={`campaign${index}`}>
              <div className={style.adsItem}>
                <Img data={ad.img_small} index={index} jumpParams={ad.jump} />
              </div>
            </JumpLink>
          ))}
        </div>
      )}
    </div>
  );
}
